export default __webpack_public_path__ + "static/Base6-08d761ff7501f70942be24a640851729.png";